import React from "react";
import { Box } from "@mui/material";
import { C } from "../common/theme";

export type Tone = "neutral" | "success" | "warning" | "danger" | "info" | "ink" | "outline" | "finished";

// Solid, darker fills with white text (owner, 2026-10-11): each state reads
// at a glance. Greens differ in lightness, not just hue.
const TONES: Record<Tone, { bg: string; fg: string; border?: string }> = {
  neutral: { bg: "#6B625B", fg: "#fff" },
  success: { bg: "#2E7D4F", fg: "#fff" },
  warning: { bg: C.coralText, fg: "#fff" },
  danger: { bg: C.danger, fg: "#fff" },
  info: { bg: C.moss, fg: "#fff" },
  ink: { bg: C.ink, fg: "#fff" },
  outline: { bg: "transparent", fg: "#3F3B38", border: "#A89A8D" },
  // Ran its course (an ended promotion): the success green, outlined.
  finished: { bg: "transparent", fg: "#2E7D4F", border: "#2E7D4F" },
};

/** A small status tag: 5px corners, one solid tone per state. */
export default function StatusPill({ tone = "neutral", children, title }: { tone?: Tone; children: React.ReactNode; title?: string }) {
  const t = TONES[tone];
  return (
    <Box
      component="span"
      title={title}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.5,
        px: 1,
        py: "3px",
        borderRadius: "5px",
        bgcolor: t.bg,
        color: t.fg,
        border: t.border ? `1px solid ${t.border}` : "1px solid transparent",
        fontSize: 12,
        fontWeight: 700,
        lineHeight: 1.35,
        whiteSpace: "nowrap",
        verticalAlign: "middle",
      }}
    >
      {children}
    </Box>
  );
}
